import { render, staticRenderFns } from "./AddFile.vue?vue&type=template&id=69583eae&scoped=true&"
import script from "./AddFile.vue?vue&type=script&lang=js&"
export * from "./AddFile.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=69583eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69583eae",
  null
  
)

export default component.exports